import { HttpInterceptorFn } from '@angular/common/http';
import { injectCurrentCustomer } from './customer-context.service';
import {
  CUSTOMER_ID_HEADER_KEY,
  DISABLE_CUSTOMER_CONTEXT,
} from './customer-context.tokens';

export const customerContextInterceptor: HttpInterceptorFn = (req, next) => {
  const shouldAddCustomerId = !req.context.get(DISABLE_CUSTOMER_CONTEXT);

  if (shouldAddCustomerId) {
    const customer = injectCurrentCustomer();
    if (customer) {
      req = req.clone({
        setHeaders: {
          [CUSTOMER_ID_HEADER_KEY]: customer.id.toString(),
        },
      });
    }
  }

  return next(req);
};
